module.exports = __webpack_public_path__ + "static/media/DB-1538_58x58x58_GX.c9275395.tom";